import { createContext } from 'react'
import type { LifeSpace } from '@/src/renderer/lib/db/models'
import type { MoveTarget } from './moveTasks'

/**
 * **„Verschieben …“** (#257, #263) — die Seite stellt den Weg bereit; gewählt wird im Panel an der
 * Zeile (Rechtsklick, Kürzel ⇧⌘M, Menü „Aufgaben“). Fehlt der Kontext, fehlt die Zeile.
 *
 * Wie `NestMenuContext`: Der Wert ändert sich nicht mit jeder Auswahl — gelesen wird sie erst beim
 * Verschieben.
 */
export interface MoveMenu {
  /**
   * Verschiebt die Aufgabe — oder die Auswahl, zu der sie gehört — ans Ende von `target`. Mit `ids`
   * genau diese: Die **Listen-Werkzeug-Pille** (#291) verschiebt nur die offenen der Auswahl.
   */
  move(taskId: string, target: MoveTarget, place: string, ids?: readonly string[]): void
  /** Legt das Projekt an (oben in seinem Lebensbereich) und verschiebt hinein (#263). `ids` wie bei `move`. */
  moveToNewProject(taskId: string, project: { name: string; lifeSpace: LifeSpace }, ids?: readonly string[]): void
  /**
   * Wie viele Aufgaben ein Verschieben an dieser Zeile mitnähme — für den Titel des Panels. Gezählt wird,
   * was wirklich wandert: keine Abschnitte (⌘A auf der Projektseite), keine Unteraufgaben.
   */
  countMoving(taskId: string, ids?: readonly string[]): Promise<number>
  /** Öffnet das Panel an der Zeile — der Rechtsklick hat kein eigenes (#263). */
  open(taskId: string): void
}

export const MoveMenuContext = createContext<MoveMenu | null>(null)
